module.exports = __webpack_public_path__ + "media/images/illustrations/online_photo_catalog_small-7e8fc8da5ce4cbf417fab9ce289382d1.svg";